module.exports = __webpack_public_path__ + "d38783f4e1fdae880b3672747f0e7a73.png";